import { Box, Button, Divider, Paper, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ActiveAddButton from "../../assets/icons/ActiveAddButton.svg";
import Highcharts from "highcharts";

const FullViewBarChart = (Props) => {
  useEffect(() => {
    const categories = Props?.data?.map((item) => item.name);

    let open_report = [];

    let close_report = [];

    Props?.data?.map((item) => {
      open_report.push(item.open_count);
      close_report.push(item.close_count);
    });

    const FullViewBarChartData = {
      chart: {
        type: "bar",
        height: 700,
      },
      title: {
        text: "",
      },
      exporting: false,
      xAxis: {
        categories: categories,
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        reversed: true,
      },
      plotOptions: {
        series: {
          stacking: "normal",
          // dataLabels: {
          //   enabled: true,
          // },
        },
      },
      series: [
        {
          name: "Open",
          data: open_report,
          color: "#7A5DF8",
          marker: {
            symbol: 'circle', 
          },
        },
        {
          name: "Close",
          data: close_report,
          color: "#F65464",
          
        },
      ],
    };

    Highcharts.chart("FullViewBarChart", FullViewBarChartData);
  }, [Props.data]);

  return (
    <>
      <Box sx={{ padding: "20px" }}>
        <div
          id="FullViewBarChart"
          style={{ width: "100%", height: "700px" }}
        ></div>
      </Box>
    </>
  );
};

export default FullViewBarChart;
